import { ALERTS_CONSENT_TEXT_VERSION, DEFAULT_ALERT_FREQUENCY } from '../../types/email-alerts';

/**
 * Turns on the signed-in user's master email-alerts subscription (PUT
 * /api/alerts/subscription). Shared by the SRP alert CTA and the follow-email
 * prompt so consent versioning and the default frequency stay in one place.
 * The server handles consent recording and (when the account email is
 * unverified) the confirmation-email flow — callers should re-check the
 * subscription status afterwards to distinguish active from pendingConfirmation.
 */
export async function subscribeToMasterAlerts(locale: 'en' | 'fi' | 'sv'): Promise<void> {
  const response = await fetch('/api/alerts/subscription', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      frequency: DEFAULT_ALERT_FREQUENCY,
      locale,
      consentTextVersion: ALERTS_CONSENT_TEXT_VERSION,
    }),
  });
  if (!response.ok) {
    throw new Error(`subscribeToMasterAlerts failed with status ${response.status}`);
  }
}
